import gql from 'graphql-tag';

export default gql`
  mutation rescheduleRsvpRepVisit($input: rescheduleRsvpRepVisitInput!) {
    rescheduleRsvpRepVisit(input: $input) {
      cancelledRepVisit {
        ...RepVisitDayDetails
      }
      bookedRepVisit {
        ...RepVisitDayDetails
      }
    }
  }
  fragment RepVisitDayDetails on RepVisitsDay {
    appointments {
      id
      bookedByCollege
      bookedByUser
      currentColleges
      status
      userBookingStatus
    }
  }
`;
